<template>
  <div>
    <div class="info-header">
      <div>
        <h2>アンサンブル流域雨量情報</h2>
      </div>
    </div>
    <div class="info-card">
      <p>
        本情報のグラフは、気象庁の以下の最新情報をもとに、全国109の一級水系の流域毎に降雨量をリアルタイムで集計<span
          class="li-num"
          >※1</span
        >し、降雨継続時間<span class="li-num">※2</span
        >における実績の流域平均累加雨量、およびアンサンブル数値予報結果に基づく流域平均累加雨量<span
          class="li-num"
          >※3※4</span
        >を表示しています。また参考に各水系の降雨継続時間における〇年に1度規模の降雨量も表示しています。これにより一級水系本川の洪水リスクをリアルタイムで確率的に把握することが可能になります。
      </p>
      <ul>
        <li>解析雨量 （30分に1回更新）</li>
        <li>メソアンサンブル数値予報モデルGPV(MEPS) （6時間に1回更新）</li>
      </ul>
      <div class="my-6 text-center">
        <img
          alt="now-icon"
          style="width: 100%"
          src="@/assets/images/views/risk-map-view/rain-ensemble.png"
        />
        <div style="font-size: 12px">
          図：過去○時間実績累加雨量とアンサンブル○時間累加雨量の表示例
        </div>
      </div>
      <div class="mt-2 pa-4" style="border: 1px dashed black">
        <p>
          <span class="li-num">※1</span>
          流域平均雨量を集計する際は、各水系の治水基準地点上流内の数値予報格子点値の単純平均を行っています。
        </p>
        <p>
          <span class="li-num">※2</span>
          降雨継続時間とは、当該時間降雨が継続して降った場合を想定して洪水の計画を立てる基準となる時間で、流域の規模や降雨特性等を勘案して流域ごとに定められています。なお解析雨量は最大48時間まで、MEPSは最大39時間まで集計をしており、降雨継続時間がその上限を超える水系の場合は上限で集計しています。
        </p>
        <p>
          <span class="li-num">※3</span>
          アンサンブル流域雨量は21メンバー（通り）の予測があり、そのばらつきも示しています（各メンバーの値を〇で、確率分布上100％、75％、50％、25％、0％相当のメンバーの値を縦棒で示しています。）
        </p>
        <p>
          <span class="li-num">※4</span>
          「メソアンサンブル数値予報モデルGPV(MEPS)」の雨量は、5kmグリッドの数値予報モデルの結果を集計しています。将来の予測そのものの不確実性に加え、線状降水帯などの局所的な豪雨の表現が難しい、系統誤差の補正がされていない等の数値予報モデルの特性を十分にご理解の上ご利用下さい。
        </p>
        <p class="mt-2" style="font-size: 12px">
          [参考資料]水害リスクマップ及び多段階の浸水想定図一覧<br />
          <a
            href="https://www.mlit.go.jp/river/kasen/ryuiki_pro/risk_map.html"
            style="word-break: break-all"
          >
            https://www.mlit.go.jp/river/kasen/ryuiki_pro/risk_map.html
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import RiskInfoBase from "./RiskInfoBase";
export default {
  name: "RainEnsembleInfo",
  extends: RiskInfoBase,
};
</script>
